import { DefinitionList } from 'modules/DefinitionList';
import { ListItem } from 'modules/List';
import { List } from './List';
import { Root } from './Root';
import { Section } from './Section';
export const Sidebar = {
    Root,
    Section,
    List,
    ListItem,
    DefinitionList: DefinitionList.Root,
    DefinitionItem: DefinitionList.Item,
    Definition: DefinitionList.Definition,
};
